import { useEffect, useState } from 'react';
import { BillingProductsSlugType } from '../enums';
import { useLazyGetProductRelationShipsQuery } from '../services/home/productApi';
import { useAppSelector } from '../store/hooks';
import { selectSelectedAccountId } from '../store/selectors/userSelectors';
export const useHasClientCenterProduct = () => {
    const selectedAccountId = useAppSelector(selectSelectedAccountId);
    const [hasClientCenter, setHasClientCenter] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [getProductRelationShips, { data: productRelationships, isLoading: isQueryLoading }] = useLazyGetProductRelationShipsQuery();
    useEffect(() => {
        if (selectedAccountId) {
            setIsLoading(true);
            getProductRelationShips({ targetValue: selectedAccountId });
        }
        else {
            setIsLoading(false);
            setHasClientCenter(false);
        }
    }, [selectedAccountId, getProductRelationShips]);
    useEffect(() => {
        if (!isQueryLoading && productRelationships !== undefined) {
            const hasActiveClientCenter = productRelationships.some(relationship => relationship.product.slug === BillingProductsSlugType.CLIENT_PORTAL && relationship.status === 'ACTIVATED');
            setHasClientCenter(hasActiveClientCenter);
            setIsLoading(false);
        }
    }, [productRelationships, isQueryLoading]);
    return {
        hasClientCenter,
        isLoading,
    };
};
